<template>
  <div class="animated fadeIn systemcss">
    <div class="row">
      <div class="col-sm-12">
        <b-card>
          <div slot="header">
            <strong>{{$t('NEWCOMPANYTYPE')}}</strong>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <b-form-fieldset v-bind:label="$t('NAME')">
                <inputvalidation :formerror="formError" name="name"><b-form-input type="text" v-model="formData.name" v-bind:placeholder="$t('NAME')"></b-form-input></inputvalidation>
              </b-form-fieldset>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <p class="bg-danger" v-if="formError.error && typeof formError.notice == 'string'">{{formError.notice}}</p>
              <b-button type="submit" class="btn button-save" v-on:click.prevent="saveRow(formData)">{{$t('SUBMIT')}}</b-button>
            </div>
          </div>
        </b-card>
      </div><!--/.col-->
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
            <div class="card-header">
               <strong>{{$t('COMPANYTYPE')}}</strong>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-sm-3">
                  <b-form-fieldset v-bind:label="$t('SEARCH')">
                    <b-form-input v-model="pagination.query"></b-form-input>
                  </b-form-fieldset>
                </div>
              </div>
            </div>
            <div class="card-body" v-if="typeof data.root == 'undefined' || !data.root.length">
              <p class="center">{{$t('NODATAFOUND')}}</p>
            </div>
            <div class="card-body" v-if="typeof data.root != 'undefined' && data.root.length">
              <table class="table table-responsive-sm table-striped table-logoped">
                <thead>
                  <tr>
                    <th>{{$t('ID')}}</th>
                    <th>{{$t('NAME')}}</th>
                    <th>{{$t('SAVE')}}</th>
                    <th>{{$t('DELETE')}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in data.root" :key="item.companyTypeId">
                    <td>{{item.companyTypeId}}</td>
                    <td><b-form-input type="text" v-model="item.name"></b-form-input></td>
                    <td><b-button type="reset" class="btn button-save" v-on:click.prevent="saveRow(item)">{{$t('SAVE')}}</b-button></td>
                    <td><b-button type="reset" class="btn button-dlt" v-on:click.prevent="deleteRow(item.companyTypeId)">{{$t('DELETE')}}</b-button></td>
                  </tr>
                </tbody>
              </table>
              <nav>
                <b-pagination align="center" :total-rows="parseInt(data.totalCount)" v-model="pagination.currentPage" :per-page="pagination.limit"></b-pagination>
              </nav>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>

import Api from '@/api/admin/CompanyType';

export default {
    name: 'CompanyTypes',
    data()
    {
        return {
            data: {},
            formError: {},
            formData:
      {
          name: '',
      },
            pagination:
      {
          query: '',
          currentPage: 1,
          limit: 20,
          searchTimeout: false,
      },
        };
    },
    created()
    {
        const me = this;
        me.getData();
    },
    methods:
  {
      async saveRow(item)
      {
          const me = this;
          try
          {
              if (typeof item.companyTypeId !== 'undefined')
              {
                  item.id = item.companyTypeId;
                  delete (item.companyTypeId);
              }

              const data = await Api.submitData(item);
              if (data.error)
              {
                  me.formError = data;
                  throw (data);
              }
              else
              {
                  me.$notify.notice(data);
                  me.formError = {};
                  me.formData.name = '';
                  await me.getData();
              }
          }
          catch (e)
          {
              me.$notify.notice(e);
          }
      },
      async getData()
      {
          const me = this;
          try
          {
              const data = await Api.selectRow(me.getParams);

              if (data.error && data.error === true)
              {
                  throw (data);
              }

              me.data = data;
          }
          catch (error)
          {
              me.$notify.notice(error);
          }
      },
      async deleteRow(id)
      {
          const me = this;
          try
          {
              me.$store.commit('setModalAlert',
                  {
                      text: me.$i18n.t('AREYOUSHURE'),
                      async btnAction()
                      {
                          const data = await Api.deleteRow(
                              {
                                  id,
                              },
                          );
                          me.$notify.notice(data);
                          await me.getData();
                      },
                  });
          }
          catch (e)
          {
              me.$notify.notice(e);
          }
      },
  },
    watch:
  {
      'pagination.currentPage'()
      {
          const me = this;
          me.getData();
      },
      'pagination.query'()
      {
          const me = this;

          if (me.pagination.searchTimeout !== false)
          {
              clearTimeout(me.pagination.searchTimeout);
          }

          me.pagination.searchTimeout = setTimeout(() =>
          {
              me.getData();
              me.pagination.searchTimeout = false;
          }, 300);
      },
  },
    computed:
  {
      getParams()
      {
          const me = this;
          const data = { ...me.pagination };
          data.start = (data.currentPage - 1) * data.limit;
          return data;
      },
  },
};
</script>
